import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Category, Classification, Group, OsPoiClassification } from "../../../types/OsPoi/OsPoiTypes"
import OsPoiClassificationsField from "./OsPoiClassificationsFields";
import {
  faCaretRight,
  faSquare as faSquareSolid,
} from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faSquareCheck, faSquare } from "@fortawesome/free-regular-svg-icons";
import { useState } from "react";

export interface OsPoiClassificationListProps {
  poiChildren: Group[] | Category[] | Classification[];
  title: string;
  handleExpanded?: (selectedItem: OsPoiClassification) => void;
  toggleSelected: (selectedItem: OsPoiClassification, selected: boolean) => void;
  isAllChildrenSelected: (Classification: OsPoiClassification) => boolean;
  isAnyChildrenSelected: (Classification: OsPoiClassification) => boolean;
}

const OsPoiClassificationList = ({
  poiChildren,
  title,
  handleExpanded,
  toggleSelected,
  isAllChildrenSelected,
  isAnyChildrenSelected
}: OsPoiClassificationListProps) => {

  const [selectedClassification, setSelectedClassification] = useState<OsPoiClassification | undefined>();

  const renderClass = (classification: Classification) => {
    const checkIcon = (isAllChildrenSelected && isAllChildrenSelected(classification)) ? (
      <FontAwesomeIcon
        icon={faSquareCheck as IconProp}
        onClick={() => toggleSelected(classification, false)}
      />
    ) : (isAnyChildrenSelected && isAnyChildrenSelected(classification)) ? (
      <FontAwesomeIcon
        icon={faSquareSolid as IconProp}
        onClick={() => toggleSelected(classification, true)}
      />
    ) : (
      <FontAwesomeIcon
        icon={faSquare as IconProp}
        onClick={() => toggleSelected(classification, true)}
      />
    );
    const subClassIndicator = classification.children ? (
      <FontAwesomeIcon
        icon={faCaretRight}
        onClick={() => handleExpanded && handleExpanded(classification)}
      />
    ) : (
      <div style={{ width: 8 }}></div>
    );
    const simpleClass = (
      <div className="d-flex align-items-center px-2 ">
        {classification.children && (
          <div
            style={{width:"315px"}}
            onClick={() => {
              if (handleExpanded) { handleExpanded(classification); }
              setSelectedClassification(classification);
            }}>
            <b>{classification.description}</b>
          </div>
        )}
        {!classification.children && (
          <div style={{width:"318px"}}>{classification.description}</div>
        )}
        {checkIcon}
        {subClassIndicator}
      </div>
    );

    return simpleClass;
  };




  return (
    <>
      <div className="d-flex flex-column mx-2 flex-shrink-0">
        <h5>{title}</h5>
        <div
          className="card overflow-auto"
          style={{ width: 355, maxHeight: 300 }}>
          {poiChildren.sort().map((classification, index) => (
            <div
              key={classification.id}
              style={{ cursor: "default" }}
              className={
                (selectedClassification === classification
                  ? "bg-primary text-white"
                  : (index % 2 === 0 ? "bg-medium" : ""))
              }
            >
              {renderClass(classification)}
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default OsPoiClassificationList